import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PremiumDiscountSummaryResponse } from 'src/app/models/premium-Discount-summary-response.model'

@Injectable({
  providedIn: 'root',
})
export class PremiumDiscountSummaryService {
  public static readonly premiumDiscountServiceEndpoint =
    '/premiumDiscountSummary'

  constructor(private readonly http: HttpClient) {}

  getPremiumDisCountSummary(
    fundId: string,
  ): Observable<PremiumDiscountSummaryResponse> {
    return this.http.get<PremiumDiscountSummaryResponse>(
      `vmf/api/${fundId}`.concat(
        PremiumDiscountSummaryService.premiumDiscountServiceEndpoint,
      ),
    )
  }
}
